import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle';
import Scrollbar from '../../components/scrollbar';
import { useParams } from 'react-router-dom';
import Footer from '../../components/footer';
import Logo from '../../images/logo.svg';
import { useFetch } from '../../hooks/useFetch';
import { fetchTeam } from '../../api/api';
import Progress from '../../components/progress';
import { useTranslation } from 'react-i18next';

const TeamSinglePage = (props) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const { data: teamDetails, isLoading, error } = useFetch(['team', id], (lang) => fetchTeam(lang, id));

    const SubmitHandler = (e) => {
        e.preventDefault();
    };

    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={teamDetails?.data?.name} pagesub={teamDetails?.data?.title} />
            <div className="team-pg-area section-padding">
                <div className="container">
                    <div className="team-info-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="team-info-img">
                                    <img src={`${process.env.REACT_APP_API_URL}/api/images/${teamDetails?.data?.image}`} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-info-text">
                                    <h2>{teamDetails?.data?.name}</h2>
                                    <ul>
                                        <li>{t('teamSinglePage.position')}: <span>{teamDetails?.data?.position}</span></li>
                                        <li>{t('teamSinglePage.experience')}:<span>{teamDetails?.data?.experianceTitle}</span></li>
                                        <li>{t('teamSinglePage.address')}:<span>{teamDetails?.data?.Address}</span></li>
                                        <li>{t('teamSinglePage.phone')}:<span>{teamDetails?.data?.Phone}</span></li>
                                        <li>{t('teamSinglePage.email')}:<span>{teamDetails?.data?.Email}</span></li>
                                        <li>{t('teamSinglePage.fax')}:<span>{teamDetails?.data?.Fax}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="exprience-area">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="exprience-wrap">
                                    <h2>{t('teamSinglePage.personalExperience')}</h2>
                                    <p>{teamDetails?.data?.experiance}</p>
                                </div>
                                <div className="at-progress">
                                    <div className="row">
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 custom-grid d-flex align-items-center justify-content-center">
                                            <div className="skill-thumb d-flex align-items-center flex-column gap-2">
                                                <Progress strokeWidth={2} percentage={teamDetails?.data?.clientSatisfiedPercent} fullNumber={teamDetails?.data?.clientSatisfiedPercent + 5} />
                                                <div className=""><span>{t('teamSinglePage.clientSatisfied')}</span></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 custom-grid d-flex align-items-center justify-content-center">
                                            <div className="skill-thumb d-flex align-items-center flex-column gap-2">
                                                <Progress strokeWidth={2} percentage={teamDetails?.data?.clientsNumber} text='+' fullNumber={teamDetails?.data?.clientsNumber + 5} />
                                                <div className=""><span>{t('teamSinglePage.happyClient')}</span></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 custom-grid d-flex align-items-center justify-content-center">
                                            <div className="skill-thumb d-flex align-items-center flex-column gap-2">
                                                <Progress strokeWidth={2} percentage={teamDetails?.data?.projectsNumber} text='+' fullNumber={teamDetails?.data?.projectsNumber + 5} />
                                                <div className=""><span>{t('teamSinglePage.projectDone')}</span></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 custom-grid d-flex align-items-center justify-content-center">
                                            <div className="skill-thumb d-flex align-items-center flex-column gap-2">
                                                <Progress strokeWidth={2} percentage={teamDetails?.data?.successPercent} fullNumber={teamDetails?.data?.successPercent + 5} />
                                                <div className=""><span>{t('teamSinglePage.success')}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="education-area ex-wiget">
                                    <h2>{t('teamSinglePage.education')}</h2>
                                    <ul>
                                        {teamDetails?.data?.education.map((item, i) => <li key={i}>{item}</li>)}
                                    </ul>
                                </div>
                                <div className="language-area ex-wiget">
                                    <h2>{t('teamSinglePage.language')}</h2>
                                    {teamDetails?.data?.languages.map((item) => item).join(', ')}
                                </div>
                                <div className="wpo-contact-area ex-wiget">
                                    <h2>{t('teamSinglePage.contactMe')}</h2>
                                    <div className="quote-form">
                                        <form onSubmit={SubmitHandler}>
                                            <div className="form-group half-col">
                                                <input type="text" className="form-control" placeholder={t('teamSinglePage.form.name')} name="name" />
                                            </div>
                                            <div className="form-group half-col">
                                                <input type="email" className="form-control" placeholder={t('teamSinglePage.form.email')} name="email" />
                                            </div>
                                            <div className="form-group half-col">
                                                <input type="text" className="form-control" placeholder={t('teamSinglePage.form.subject')} name="subject" />
                                            </div>
                                            <div className="form-group half-col">
                                                <input type="text" className="form-control" placeholder={t('teamSinglePage.form.address')} name="address" />
                                            </div>
                                            <div className="form-group full-col">
                                                <textarea className="form-control" name="note" placeholder={t('teamSinglePage.form.description')}></textarea>
                                            </div>
                                            <div className="form-group full-col">
                                                <button className="btn theme-btn" type="submit">{t('teamSinglePage.form.submit')}</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    );
};

export default TeamSinglePage;
